import React from 'react';
import { Col, DatePicker, Form, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from '../../style.module.scss';

const InfoSection = ({ shoppingCenters }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((shoppingCenter) => (
              <Select.Option key={shoppingCenter.id} value={shoppingCenter.id}>
                {shoppingCenter.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Date')} name='year'>
          <DatePicker format={'DD MMMM YYYY'} className={styles.editPicker} picker={'year'} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
